import Hashids from 'hashids';

// Initialize with your secret salt (store in .env in production)
const hashids = new Hashids('your-ward-salt', 8);

export const encryptId = (id: number): string => {
  return hashids.encode(id);
};

export const decryptId = (hash: string): number => {
  const decoded = hashids.decode(hash);
  return decoded.length > 0 ? Number(decoded[0]) : -1;
};